import styled from '@emotion/styled'
import { Text, Title } from 'components/Typography'
import { BREAKPOINTS } from 'utils/styled'

export const SWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  @media ${BREAKPOINTS.MD.max} {
    flex-direction: column-reverse;
    overflow: hidden;
  }
`

export const STextWrapper = styled.div`
  margin-right: 7rem;
  flex: 1;

  position: relative;

  &:before {
    content: '';
    border: 2px solid var(--c-blue100);
    position: absolute;
    z-index: -1;
    top: -1.6875rem;
    left: 1.75rem;
    right: -2.5rem;
    bottom: -2.5rem;

    @media ${BREAKPOINTS.MD.max} {
      top: -16rem;
      left: 4rem;
      bottom: 8rem;
    }
  }

  @media ${BREAKPOINTS.MD.max} {
    margin-right: 0;
  }
`

export const STitle = styled(Title)`
  margin-bottom: 1.5rem;
  font-size: 2.25rem !important;
`

export const SText = styled(Text)`
  margin-bottom: 2rem;

  @media ${BREAKPOINTS.MD.max} {
    margin-bottom: 1.5rem;
  }
`

export const SImageWrapper = styled.div`
  flex: 1;
  width: 100%;

  @media ${BREAKPOINTS.MD.max} {
    margin-bottom: 1.5rem;
  }

  img {
    width: 100%;
    object-fit: contain;
  }
`
